import React from 'react';
import Section from '~/shared/Section';
import { Caption } from '~/shared/Typography';

export const Debug = () => {

    return (
        <Section flex={1}>
            <Caption>debug</Caption>
        </Section>
    );
};
